// extracted by mini-css-extract-plugin
export default {"nav-switcher-submenu":"index_nav-switcher-submenu__GFd8f","switcher":"index_switcher__-+g7o"};